import { Progress, Tooltip } from "@mantine/core";
import "./CompletedClientsBar.scss";
import type { HomePageStatus } from "../../../../types";

interface CompletedClientsBarProps {
  clientStatusBar: HomePageStatus;
  clientStatus: HomePageStatus & { Completed: number };
}

const CompletedClientsBar = ({
  clientStatusBar,
  clientStatus,
}: CompletedClientsBarProps) => {
  clientStatusBar = {
    ...clientStatusBar,
  };

  clientStatus = {
    ...clientStatus,
  };

  const keys = Object.keys(clientStatusBar);
  const reportStatuses = keys.slice(0, -1); // Exclude the last key Archived

  const pluralizeClient = (count: number) => {
    return `${count} client${count === 1 ? "" : "s"}`;
  };

  return (
    <div className="clients-bar">
      <p className="status-label">Other Statuses</p>
      <Progress.Root size={25}>
        <Tooltip withArrow label={pluralizeClient(clientStatus["Onboarding"])}>
          <Progress.Section
            value={clientStatusBar["Onboarding"] ?? 0}
            color="#5C59E8"
          >
            <Progress.Label></Progress.Label>
          </Progress.Section>
        </Tooltip>
        <Tooltip withArrow label={pluralizeClient(clientStatus["In Queue"])}>
          <Progress.Section
            value={clientStatusBar["In Queue"] ?? 0}
            color="#00AEEF"
          >
            <Progress.Label></Progress.Label>
          </Progress.Section>
        </Tooltip>
        <Tooltip withArrow label={pluralizeClient(clientStatus["In Progress"])}>
          <Progress.Section
            value={clientStatusBar["In Progress"] ?? 0}
            color="#0077CC"
          >
            <Progress.Label></Progress.Label>
          </Progress.Section>
        </Tooltip>
        <Tooltip withArrow label={pluralizeClient(clientStatus["Quote Sent"])}>
          <Progress.Section
            value={clientStatusBar["Quote Sent"] ?? 0}
            color="#F16E00"
          >
            <Progress.Label></Progress.Label>
          </Progress.Section>
        </Tooltip>
        <Tooltip
          withArrow
          label={pluralizeClient(clientStatus["Signatures Requested"])}
        >
          <Progress.Section
            value={clientStatusBar["Signatures Requested"] ?? 0}
            color="#DC373A"
          >
            <Progress.Label></Progress.Label>
          </Progress.Section>
        </Tooltip>
        <Tooltip
          withArrow
          label={pluralizeClient(clientStatus["Return Filed"])}
        >
          <Progress.Section
            value={clientStatusBar["Return Filed"] ?? 0}
            color="#0A4A6E"
          >
            <Progress.Label></Progress.Label>
          </Progress.Section>
        </Tooltip>
      </Progress.Root>
      {/* key for what the different colors of the statuses mean */}
      <div className="status-key">
        {reportStatuses.map((item, index) => (
          <div key={`${item}-${index}`} className="status-key-item">
            <div className={`circle circle${index + 1}`}></div>
            <p className={`status-text${index + 1}`}>{item}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompletedClientsBar;
